import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Linkedin, Twitter, Mail, MapPin, Heart } from "lucide-react";
import ecocupidLogo from "@/assets/ecocupid-logo.png";
import { AccessibilityMenu } from "@/components/AccessibilityMenu";
const socialLinks = [{
  icon: Facebook,
  href: "https://facebook.com/ecocupid",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "https://instagram.com/ecocupid",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "https://youtube.com/@ecocupid",
  label: "YouTube"
}, {
  icon: Linkedin,
  href: "https://linkedin.com/company/ecocupid",
  label: "LinkedIn"
}];
const footerLinks = {
  explore: [{
    path: "/",
    label: "Stories"
  }, {
    path: "/about",
    label: "About Us"
  }],
  getInvolved: [{
    path: "/contact",
    label: "Contact Us"
  }, {
    path: "/faq",
    label: "FAQ"
  }]
};
export const Footer = () => {
  return <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img src={ecocupidLogo} alt="EcoCupid - Connect Share Greener Future" className="h-16 w-auto brightness-100" />
            </div>
            <p className="text-primary-foreground/80 text-sm mb-4">
              EcoCupid is a community for Southeast Asia’s environmentalists, and we inspire action for a sustainable future through storytelling.
            </p>
            <div className="flex gap-3">
              {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-primary-foreground/10 flex items-center justify-center hover:bg-primary-foreground/20 transition-colors" aria-label={social.label}>
                    <social.icon className="w-4 h-4" />
                </a>)}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Explore</h3>
            <ul className="space-y-2">
              {footerLinks.explore.map(link => <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Get Involved</h3>
            <ul className="space-y-2">
              {footerLinks.getInvolved.map(link => <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-primary-foreground/80">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>enquiry@ecocupid-asean.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-primary-foreground/80">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>ASEAN Based, Incorporated in Singapore as EcoCupid SG, UEN: 202505556K</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-primary-foreground flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-accent fill-accent" /> for Planet Earth © {new Date().getFullYear()} EcoCupid
          </p>
          <div className="flex items-center gap-4">
            <AccessibilityMenu appearance="footer" />
            <div id="wcb" className="carbonbadge" />
          </div>
        </div>
      </div>
    </footer>;
};